/* AW Library | aw-cart.js | v0.3.0
   המנוע של העגלה, משותף למגירת העגלה (aw-cart-drawer) ולעמוד העגלה (aw-cart).

   לא תלוי בתמה: מדבר ישירות עם ה-Cart API של Shopify (/cart.js, /cart/change.js) ובונה את התצוגה בעצמו.
   לכן הוא עובד אותו דבר ב-Shrine, Dawn, Horizon, Eurus ו-Venue, בלי לגעת ב-JS של התמה.

   כל הטקסטים, האייקונים וההגדרות מגיעים מהסקשן (data-aw-cart-config ותגי template), כך שאין כאן מחרוזת קשיחה.
   המחירים וההנחות מוצגים כמו ש-Shopify מחזיר אותם. אין כאן חישוב הנחה משלנו.

   אירועים:
     aw:cart:open      לפתוח את המגירה (אחרי רענון העגלה). detail.opener = האלמנט שפתח, לחזרת הפוקוס
     aw:cart:refresh   לרענן את העגלה בלי לפתוח
     aw:cart:updated   נשלח אחרי כל שינוי, עם העגלה ב-detail

   v0.3.0: פס התקדמות בסגנון "מדרגות" (עיגול אייקון ושם מתחת לכל מדרגה), ומוצרים משלימים בקרוסלה
   עם הוספה מהירה. המוצרים נבחרים בסקשן, או מגיעים מההמלצות של Shopify למוצר הראשון בעגלה.

   ונילה, בלי תלויות. בטוח לטעינה כפולה. */
(function () {
  if (window.AWCart) return;

  var roots = [];
  var cart = null;
  var lastOpener = null;
  /* המלצות של Shopify לפי מוצר: נטענות פעם אחת לכל מוצר */
  var recs = {};

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    function group(n, sep) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    var map = {
      amount: group(parts[0], ',') + '.' + parts[1],
      amount_no_decimals: group(String(Math.round(cents / 100)), ','),
      amount_with_comma_separator: group(parts[0], '.') + ',' + parts[1],
      amount_no_decimals_with_comma_separator: group(String(Math.round(cents / 100)), '.'),
      amount_with_apostrophe_separator: group(parts[0], "'") + '.' + parts[1],
      amount_no_decimals_with_space_separator: group(String(Math.round(cents / 100)), ' '),
      amount_with_space_separator: group(parts[0], ' ') + ',' + parts[1]
    };
    var text = String(format || '').replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) { return map[key] || map.amount; });
    /* סכום עגול בלי אגורות: "94 ₪" ולא "94.00 ₪". סכום עם אגורות נשאר כמו שהוא */
    return cents % 100 === 0 ? text.replace(/[.,]00(?!\d)/, '') : text;
  }

  /* החלפת צבע בתוך העגלה, כשכל צבע הוא מוצר נפרד (הגדרת "swap" בסקשן) */
  function swapSelect(c, item) {
    var list = c.swap || [];
    var inList = false;
    for (var i = 0; i < list.length; i++) if (list[i].product === item.product_id) inList = true;
    if (!inList || list.length < 2) return '';
    var options = '';
    for (var j = 0; j < list.length; j++) {
      options += '<option value="' + list[j].variant + '"' + (list[j].product === item.product_id ? ' selected' : '') + (list[j].available ? '' : ' disabled') + '>' + esc(list[j].name) + '</option>';
    }
    return '<label class="aw-cart__swap"><span>' + esc(c.swapLabel || '') + '</span><select data-aw-cart-swap data-from="' + item.variant_id + '">' + options + '</select></label>';
  }

  function esc(value) {
    return String(value === null || value === undefined ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function fill(template, map) {
    return String(template || '').replace(/\[(\w+)\]/g, function (match, key) { return key in map ? map[key] : match; });
  }

  function view(root) {
    var c = root.config;
    var t = c.texts;
    var icon = root.icons;
    var fmt = c.moneyFormat;
    var count = cart ? cart.item_count : 0;

    var head =
      '<div class="aw-cart__head">' +
        '<h2 class="aw-cart__title" id="' + root.titleId + '">' + esc(t.title) + (count ? ' <span class="aw-cart__count">(' + count + ')</span>' : '') + '</h2>' +
        '<button type="button" class="aw-cart__close" aria-label="' + esc(t.close) + '" data-aw-cart-close>' + icon.cross + '</button>' +
      '</div>';

    if (!cart || !cart.items.length) {
      return head +
        '<div class="aw-cart__empty">' +
          '<span class="aw-cart__empty-icon" aria-hidden="true">' + icon.bag + '</span>' +
          '<p class="aw-cart__empty-title">' + esc(t.emptyTitle) + '</p>' +
          (t.emptyText ? '<p class="aw-cart__empty-text">' + esc(t.emptyText) + '</p>' : '') +
          (t.emptyButton && c.emptyUrl ? '<a href="' + esc(c.emptyUrl) + '" class="aw-btn">' + esc(t.emptyButton) + '</a>' : '') +
        '</div>';
    }

    /* פס ההתקדמות: עד שתי מדרגות (למשל משלוח חינם, ואז מתנה). הטקסט מדבר תמיד על המדרגה הבאה. */
    var ship = '';
    var steps = c.milestones || [];
    if (steps.length) {
      var top = steps[steps.length - 1].amount;
      var next = null;
      var marks = '';
      var stepsStyle = c.progressStyle === 'steps';
      for (var m = 0; m < steps.length; m++) {
        var reached = cart.total_price >= steps[m].amount;
        if (!reached && !next) next = steps[m];
        var at = ((steps[m].amount / top) * 100).toFixed(1);
        if (stepsStyle) {
          marks +=
            '<span class="aw-cart__step' + (reached ? ' is-reached' : '') + (m === steps.length - 1 ? ' is-last' : '') + '" style="inset-inline-start: ' + at + '%">' +
              '<span class="aw-cart__step-icon" aria-hidden="true">' + (reached ? icon.check : (icon[steps[m].icon] || icon.truck)) + '</span>' +
              '<span class="aw-cart__step-label">' + esc(steps[m].label) + '</span>' +
              (c.stepHint ? '<span class="aw-cart__step-hint">' + esc(fill(c.stepHint, { amount: money(steps[m].amount, fmt) })) + '</span>' : '') +
            '</span>';
        } else {
          marks += '<span class="aw-cart__ship-mark' + (reached ? ' is-reached' : '') + '" style="inset-inline-start: ' + at + '%">' + icon.check + '</span>';
        }
      }
      /* הסכום שנשאר מודגש: זה המספר היחיד שהקונה צריך לראות בשורה הזו */
      var line = next
        ? esc(next.progress).replace('[amount]', '<strong class="aw-cart__ship-amount">' + esc(money(next.amount - cart.total_price, fmt)) + '</strong>')
        : esc(steps[steps.length - 1].done);
      ship =
        '<div class="aw-cart__ship' + (next ? '' : ' is-complete') + (stepsStyle ? ' aw-cart__ship--steps' : '') + '">' +
          '<span class="aw-cart__ship-line">' + (stepsStyle ? '' : (next ? icon.truck : icon.check)) + '<span>' + line + '</span></span>' +
          '<div class="aw-cart__ship-track"><div class="aw-cart__ship-bar"><div class="aw-cart__ship-fill"></div></div>' + marks + '</div>' +
        '</div>';
    } else if (t.shipNote) {
      ship = '<div class="aw-cart__ship"><span class="aw-cart__ship-line">' + icon.truck + '<span>' + esc(t.shipNote) + '</span></span></div>';
    }

    var items = '';
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var variant = item.product_has_only_default_variant ? '' : item.variant_title;
      var discounts = '';
      var allocations = item.line_level_discount_allocations || [];
      for (var d = 0; d < allocations.length; d++) {
        var title = allocations[d].discount_application && allocations[d].discount_application.title;
        if (title) discounts += '<span class="aw-cart__discount">' + icon.check + esc(title) + '</span>';
      }
      items +=
        '<li class="aw-cart__item" data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '">' +
          '<a class="aw-cart__thumb" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
            (item.image ? '<img src="' + esc(sized(item.image, 220)) + '" alt="" width="110" height="110" loading="lazy">' : '') +
          '</a>' +
          '<div class="aw-cart__info">' +
            '<div class="aw-cart__row">' +
              '<a class="aw-cart__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              '<span class="aw-cart__price">' +
                '<span class="aw-cart__price-now">' + esc(money(item.final_line_price, fmt)) + '</span>' +
                (item.original_line_price > item.final_line_price ? '<span class="aw-cart__price-was">' + esc(money(item.original_line_price, fmt)) + '</span>' : '') +
              '</span>' +
            '</div>' +
            (variant ? '<span class="aw-cart__variant">' + esc(variant) + '</span>' : '') +
            swapSelect(c, item) +
            discounts +
            '<div class="aw-cart__controls">' +
              '<span class="aw-cart__qty">' +
                '<button type="button" class="aw-cart__qty-btn" aria-label="' + esc(t.decrease) + '" data-aw-cart-step="-1">' + icon.dash + '</button>' +
                '<span class="aw-cart__qty-value" aria-live="polite">' + item.quantity + '</span>' +
                '<button type="button" class="aw-cart__qty-btn" aria-label="' + esc(t.increase) + '" data-aw-cart-step="1">' + icon.plus + '</button>' +
              '</span>' +
              '<button type="button" class="aw-cart__remove' + (icon.trash ? ' aw-cart__remove--icon' : '') + '" aria-label="' + esc(t.remove) + '" data-aw-cart-remove>' + (icon.trash || esc(t.remove)) + '</button>' +
            '</div>' +
          '</div>' +
        '</li>';
    }

    /* הצעת שדרוג כמות: רק כשיש בעגלה שורה אחת, בכמות שהוגדרה */
    /* שדרוג למארז: מסכה אחת = מארז של מסכה אחת באותו צבע, שתי מסכות = מארז זוג באותם צבעים.
       המסכות מזוהות לפי רשימת החלפת הצבע (swap), והצירוף נכתב בסדר שלה ("שחור + אדום"). */
    var bundleUp = '';
    var ups = c.bundleUps || [];
    if (ups.length && cart.items.length) {
      var swapList = c.swap || [];
      var orderOf = {}, nameOf = {};
      for (var w = 0; w < swapList.length; w++) { orderOf[swapList[w].product] = w; nameOf[swapList[w].product] = swapList[w].name; }
      var bundleIds = ups.map(function (u) { return u.product; });
      var hasBundle = cart.items.some(function (it) { return bundleIds.indexOf(it.product_id) > -1; });
      var masks = [];
      cart.items.forEach(function (it) { if (it.product_id in nameOf) for (var q = 0; q < it.quantity; q++) masks.push(it); });
      var offer = !hasBundle && ups.filter(function (u) { return u.units === masks.length; })[0];
      if (offer) {
        masks.sort(function (a, b) { return orderOf[a.product_id] - orderOf[b.product_id]; });
        var combo = masks.map(function (it) { return nameOf[it.product_id]; }).join(' + ');
        var target = offer.variants.filter(function (v) { return v.title === combo && v.available; })[0];
        if (target) {
          var remove = masks.map(function (it) { return it.variant_id; }).filter(function (id, idx, all) { return all.indexOf(id) === idx; });
          bundleUp =
            '<div class="aw-cart__upgrade">' +
              '<span class="aw-cart__upgrade-text">' + esc(offer.text) + '</span>' +
              '<button type="button" class="aw-btn aw-cart__upgrade-btn" data-aw-cart-bundle-up="' + target.id + '" data-remove="' + remove.join(',') + '">' + esc(c.bundleUpButton || '') + '</button>' +
            '</div>';
        }
      }
    }

    var upgrade = '';
    var up = c.upgrade;
    if (up && cart.items.length === 1 && cart.items[0].quantity === up.from && (!up.match || String(cart.items[0].handle || '').indexOf(up.match) > -1)) {
      upgrade =
        '<div class="aw-cart__upgrade">' +
          '<span class="aw-cart__upgrade-text">' + esc(up.text) + '</span>' +
          '<button type="button" class="aw-btn aw-cart__upgrade-btn" data-aw-cart-upgrade="' + up.to + '">' + esc(up.button) + '</button>' +
        '</div>';
    }

    var upsell = upsellView(root);

    /* הנחות ברמת העגלה, כמו ש-Shopify חישב אותן */
    var savings = '';
    var applications = cart.cart_level_discount_applications || [];
    for (var a = 0; a < applications.length; a++) {
      savings +=
        '<div class="aw-cart__sum-row aw-cart__sum-row--saving">' +
          '<span>' + esc(applications[a].title) + '</span>' +
          '<span>-' + esc(money(applications[a].total_allocated_amount, fmt)) + '</span>' +
        '</div>';
    }

    /* שורת מתנה קבועה: מה שמצורף לכל הזמנה, עם מחיר אפס, כדי שהקונה יראה אותו כחלק מהסל */
    var gift = t.giftLine
      ? '<div class="aw-cart__sum-row aw-cart__sum-row--gift"><span>' + (icon.gift || '') + '<span>' + esc(t.giftLine) + '</span></span><span class="aw-cart__gift-price">' + esc(String(t.giftPrice).replace(/[.,]00(?!\d)/, '')) + '</span></div>'
      : '';

    /* השורה שמתחת לסכום: אחרי שהגיעו לסכום המשלוח החינם, היא אומרת את זה במקום "מחושב בקופה" */
    var shipReached = steps.length && cart.total_price >= steps[0].amount;
    var noteText = shipReached && t.noteDone ? t.noteDone : t.note;

    var assure = '';
    for (var s = 0; s < c.assurances.length; s++) assure += '<li>' + icon.check + esc(c.assurances[s]) + '</li>';

    return head + ship +
      '<div class="aw-cart__body">' +
        '<ul class="aw-cart__items">' + items + '</ul>' +
        (bundleUp || upgrade) +
        upsell +
        '<p class="aw-cart__error" role="alert" hidden data-aw-cart-error></p>' +
      '</div>' +
      '<div class="aw-cart__foot">' +
        gift +
        savings +
        '<div class="aw-cart__sum-row aw-cart__sum-row--total"><span>' + esc(t.subtotal) + '</span><span>' + esc(money(cart.total_price, fmt)) + '</span></div>' +
        (noteText ? '<p class="aw-cart__note">' + esc(noteText) + '</p>' : '') +
        '<a href="' + esc(c.routes.checkout) + '" class="aw-btn aw-cart__checkout">' + esc(t.checkout) + '</a>' +
        (root.payments ? '<div class="aw-cart__pay" aria-hidden="true">' + root.payments + '</div>' : '') +
        (assure ? '<ul class="aw-cart__assure">' + assure + '</ul>' : '') +
        '<button type="button" class="aw-cart__continue" data-aw-cart-close>' + esc(t.keepShopping) + '</button>' +
      '</div>';
  }


  /* מוצרים משלימים: מה שנבחר בסקשן, ואם לא נבחר כלום, ההמלצות של Shopify למוצר הראשון בעגלה.
     מוצר שכבר בעגלה או שאזל לא מוצג. */
  function upsellItems(root) {
    var u = root.config.upsell;
    if (!u || !cart || !cart.items.length) return [];
    var inCart = {};
    for (var i = 0; i < cart.items.length; i++) inCart[cart.items[i].product_id] = true;
    var list = u.products || [];
    if (!list.length && u.auto) {
      var pid = cart.items[0].product_id;
      if (recs[pid] === undefined) {
        recs[pid] = null;
        loadRecs(u, pid);
      }
      list = recs[pid] || [];
    }
    return list.filter(function (p) { return p.available && !inCart[p.id]; });
  }

  function loadRecs(u, pid) {
    var base = u.recommendations || '/recommendations/products';
    function get(intent) {
      return fetch(base + '.json?product_id=' + pid + '&limit=6&intent=' + intent, { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : { products: [] }; })
        .then(function (data) { return data.products || []; });
    }
    /* קודם "משלים" (מוגדר באפליקציית Search & Discovery), ואם אין, "קשור" */
    get('complementary')
      .then(function (list) { return list.length ? list : get('related'); })
      .then(function (list) {
        recs[pid] = list.map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
          var img = p.featured_image || '';
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          return { id: p.id, variant: v.id, title: p.title, subtitle: '', price: v.price, compare: v.compare_at_price || 0, image: img ? sized(img, 240) : '', url: p.url, available: p.available && !!v.id };
        });
        if (recs[pid].length) paint();
      })
      .catch(function () { recs[pid] = []; });
  }

  function upsellView(root) {
    var items = upsellItems(root);
    if (!items.length) return '';
    var c = root.config;
    var u = c.upsell;
    var cards = '';
    for (var i = 0; i < items.length; i++) {
      var p = items[i];
      cards +=
        '<li class="aw-cart__up-card">' +
          '<a class="aw-cart__up-thumb" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</a>' +
          '<div class="aw-cart__up-info">' +
            '<a class="aw-cart__up-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            (p.subtitle ? '<span class="aw-cart__up-sub">' + esc(p.subtitle) + '</span>' : '') +
            '<span class="aw-cart__up-price"><span class="aw-cart__price-now">' + esc(money(p.price, c.moneyFormat)) + '</span>' +
              (p.compare > p.price ? '<span class="aw-cart__price-was">' + esc(money(p.compare, c.moneyFormat)) + '</span>' : '') + '</span>' +
          '</div>' +
          '<button type="button" class="aw-btn aw-cart__up-add" data-aw-cart-add="' + p.variant + '">' + esc(u.button) + '</button>' +
        '</li>';
    }
    var arrows = items.length > 1
      ? '<span class="aw-cart__up-arrows">' +
          '<button type="button" class="aw-cart__up-arrow aw-cart__up-arrow--prev" aria-label="' + esc(c.texts.prev) + '" data-aw-cart-up="-1">' + root.icons.chevron + '</button>' +
          '<button type="button" class="aw-cart__up-arrow aw-cart__up-arrow--next" aria-label="' + esc(c.texts.next) + '" data-aw-cart-up="1">' + root.icons.chevron + '</button>' +
        '</span>'
      : '';
    return '<div class="aw-cart__up">' +
      '<div class="aw-cart__up-head"><p class="aw-cart__up-title">' + esc(u.title) + '</p>' + arrows + '</div>' +
      '<ul class="aw-cart__up-track" data-aw-cart-up-track>' + cards + '</ul>' +
    '</div>';
  }

  function addVariant(id, button) {
    if (button) { button.disabled = true; button.classList.add('is-busy'); }
    return fetch((roots.length ? roots[0].config.routes.cart : '/cart') + '/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          if (button) { button.disabled = false; button.classList.remove('is-busy'); }
          showError(result.data.description || result.data.message || '');
          return;
        }
        return load();
      })
      .catch(function () { if (button) { button.disabled = false; button.classList.remove('is-busy'); } });
  }

  function paint() {
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      root.mount.innerHTML = view(root);
      var steps = root.config.milestones || [];
      if (steps.length && cart) {
        var progress = Math.max(0, Math.min(100, (cart.total_price / steps[steps.length - 1].amount) * 100));
        /* הפס מתמלא אחרי שהתוכן צויר, כדי שהמילוי יהיה אנימציה ולא קפיצה */
        (function (el, value) {
          window.requestAnimationFrame(function () { el.style.setProperty('--aw-cart-progress', value); });
        })(root.el, progress.toFixed(1) + '%');
      }
    }
    document.dispatchEvent(new CustomEvent('aw:cart:updated', { detail: cart }));
  }

  function routes() {
    return roots.length ? roots[0].config.routes : { cart: '/cart', change: '/cart/change' };
  }

  function load() {
    return fetch(routes().cart + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (data) { cart = data; paint(); return data; })
      .catch(function () { return cart; });
  }

  function showError(message) {
    for (var i = 0; i < roots.length; i++) {
      var box = roots[i].mount.querySelector('[data-aw-cart-error]');
      if (!box) continue;
      box.textContent = message || '';
      box.hidden = !message;
    }
  }

  function change(key, quantity, itemEl) {
    if (itemEl) itemEl.classList.add('is-busy');
    return fetch(routes().change + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          /* למשל: אין מספיק מלאי. מרעננים, ומציגים את ההודעה ש-Shopify החזיר. */
          return load().then(function () { showError(result.data.description || result.data.message || ''); });
        }
        cart = result.data;
        paint();
        /* התשובה של cart/change לפעמים מחזירה סכום כולל לפני שהנחה אוטומטית חושבה מחדש (נמצא ב-ONEWHEEIL: 243 ₪ במקום 216 ₪).
           לכן מושכים את העגלה שוב, והסכום הנכון מחליף את זה מהתשובה. */
        return load();
      })
      .catch(function () { if (itemEl) itemEl.classList.remove('is-busy'); });
  }

  function drawer() {
    for (var i = 0; i < roots.length; i++) if (roots[i].kind === 'drawer') return roots[i];
    return null;
  }

  function open(opener) {
    var root = drawer();
    if (!root) return false;
    lastOpener = opener || document.activeElement;
    root.el.classList.toggle('is-rtl', getComputedStyle(root.el).direction === 'rtl');
    root.el.classList.add('is-open');
    root.el.removeAttribute('aria-hidden');
    document.documentElement.style.overflow = 'hidden';
    var close = root.mount.querySelector('[data-aw-cart-close]');
    if (close) close.focus({ preventScroll: true });
    return true;
  }

  function close() {
    var root = drawer();
    if (!root || !root.el.classList.contains('is-open')) return;
    root.el.classList.remove('is-open');
    root.el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastOpener && lastOpener.focus) lastOpener.focus({ preventScroll: true });
  }

  function onSwap(event) {
    var select = event.target.closest && event.target.closest('[data-aw-cart-swap]');
    if (!select) return;
    var itemEl = select.closest('[data-key]');
    var from = parseInt(select.getAttribute('data-from'), 10);
    var qty = parseInt(itemEl.getAttribute('data-qty'), 10) || 1;
    itemEl.classList.add('is-busy');
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    /* מורידים את הצבע הישן לפי מזהה הווריאנט (המפתח של השורה משתנה כשהנחה מתחלקת מחדש), ואז מוסיפים את החדש באותה כמות */
    fetch(routes().change + '.js', { method: 'POST', credentials: 'same-origin', headers: headers, body: JSON.stringify({ id: String(from), quantity: 0 }) })
      .then(function () { return fetch(routes().cart + '/add.js', { method: 'POST', credentials: 'same-origin', headers: headers, body: JSON.stringify({ items: [{ id: parseInt(select.value, 10), quantity: qty }] }) }); })
      .then(function () { return load(); })
      .catch(function () { return load(); });
  }

  function onClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-aw-cart-close]')) {
      close();
      return;
    }
    var itemEl = target.closest('.aw-cart__item');
    var step = target.closest('[data-aw-cart-step]');
    if (step && itemEl) {
      var quantity = parseInt(itemEl.getAttribute('data-qty'), 10) + parseInt(step.getAttribute('data-aw-cart-step'), 10);
      change(itemEl.getAttribute('data-key'), Math.max(0, quantity), itemEl);
      return;
    }
    if (target.closest('[data-aw-cart-remove]') && itemEl) {
      change(itemEl.getAttribute('data-key'), 0, itemEl);
      return;
    }
    var add = target.closest('[data-aw-cart-add]');
    if (add) {
      addVariant(parseInt(add.getAttribute('data-aw-cart-add'), 10), add);
      return;
    }
    /* חיצי הקרוסלה: "הבא" זז לכיוון סוף השורה, בכל כיוון כתיבה */
    var arrow = target.closest('[data-aw-cart-up]');
    if (arrow) {
      var track = arrow.closest('.aw-cart__up').querySelector('[data-aw-cart-up-track]');
      var card = track && track.firstElementChild;
      if (card) {
        var rtl = getComputedStyle(track).direction === 'rtl';
        var step = (card.getBoundingClientRect().width + 10) * parseInt(arrow.getAttribute('data-aw-cart-up'), 10);
        track.scrollBy({ left: rtl ? -step : step, behavior: 'smooth' });
      }
      return;
    }
    var bundleBtn = target.closest('[data-aw-cart-bundle-up]');
    if (bundleBtn) {
      bundleBtn.disabled = true;
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var updates = {};
      bundleBtn.getAttribute('data-remove').split(',').forEach(function (id) { if (id) updates[id] = 0; });
      fetch(routes().cart + '/update.js', { method: 'POST', credentials: 'same-origin', headers: headers, body: JSON.stringify({ updates: updates }) })
        .then(function () { return fetch(routes().cart + '/add.js', { method: 'POST', credentials: 'same-origin', headers: headers, body: JSON.stringify({ items: [{ id: parseInt(bundleBtn.getAttribute('data-aw-cart-bundle-up'), 10), quantity: 1 }] }) }); })
        .then(function () { return load(); })
        .catch(function () { return load(); });
      return;
    }
    var upgrade = target.closest('[data-aw-cart-upgrade]');
    if (upgrade && cart && cart.items.length) {
      change(cart.items[0].key, parseInt(upgrade.getAttribute('data-aw-cart-upgrade'), 10), null);
    }
  }

  function onKey(event) {
    var root = drawer();
    if (!root || !root.el.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    /* הפוקוס נשאר בתוך המגירה כל עוד היא פתוחה */
    var focusable = root.el.querySelectorAll('a[href], button:not([disabled]):not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function init(scope) {
    var list = (scope || document).querySelectorAll('[data-aw-cart-root]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.__awCart) continue;
      el.__awCart = true;
      var config;
      try { config = JSON.parse(el.querySelector('[data-aw-cart-config]').textContent); } catch (error) { continue; }
      var icons = {};
      var templates = el.querySelectorAll('template[data-aw-cart-icon]');
      for (var t = 0; t < templates.length; t++) icons[templates[t].getAttribute('data-aw-cart-icon')] = templates[t].innerHTML.trim();
      if (!cart) {
        try { cart = JSON.parse(el.querySelector('[data-aw-cart-data]').textContent); } catch (error) {}
      }
      var mount = el.querySelector('[data-aw-cart-mount]');
      var payTemplate = el.querySelector('template[data-aw-cart-payments]');
      roots.push({ el: el, mount: mount, config: config, icons: icons, payments: payTemplate ? payTemplate.innerHTML.trim() : '', kind: el.getAttribute('data-aw-cart-root'), titleId: mount.getAttribute('data-title-id') });
      el.addEventListener('click', onClick);
      el.addEventListener('change', onSwap);
    }
    /* סקשן שהוסר בעורך התמות */
    roots = roots.filter(function (root) { return document.contains(root.el); });
    if (roots.length) paint();
  }

  document.addEventListener('keydown', onKey);
  document.addEventListener('aw:cart:open', function (event) {
    var opener = event.detail && event.detail.opener;
    load().then(function () { open(opener); });
  });
  document.addEventListener('aw:cart:refresh', load);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  /* חזרה לעמוד מהקופה או מהיסטוריית הדפדפן: העגלה אולי השתנתה */
  window.addEventListener('pageshow', function (event) { if (event.persisted) { close(); load(); } });

  window.AWCart = { open: open, close: close, refresh: load, hasDrawer: function () { return !!drawer(); } };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
